import type { ReturnedPortfolio } from '../components/Create-Portfolio/types';

function flag(
  portfolio: Record<string, unknown>,
  camel: string,
  snake: string,
  fallback = false
): boolean {
  if (camel in portfolio) return Boolean(portfolio[camel]);
  if (snake in portfolio) return Boolean(portfolio[snake]);
  return fallback;
}

function mapFilesUrl(item: Record<string, unknown>): string[] {
  if (Array.isArray(item.filesUrl)) {
    return item.filesUrl.map((f) => String(f));
  }
  const single = String(item.fileUrl ?? item.file_url ?? '').trim();
  return single ? [single] : [];
}

function mapItem<T extends Record<string, unknown>>(item: T): T & { filesUrl: string[] } {
  return {
    ...item,
    filesUrl: mapFilesUrl(item),
  };
}

export function normalizePublicPortfolio(
  portfolio: Record<string, unknown> | null | undefined
): ReturnedPortfolio | null {
  if (!portfolio) {
    return null;
  }

  const projects = Array.isArray(portfolio.projects)
    ? portfolio.projects.map((item) => mapItem(item as Record<string, unknown>))
    : [];
  const accomplishments = Array.isArray(portfolio.accomplishments)
    ? portfolio.accomplishments.map((item) => mapItem(item as Record<string, unknown>))
    : [];
  const certifications = Array.isArray(portfolio.certifications)
    ? portfolio.certifications.map((item) => mapItem(item as Record<string, unknown>))
    : [];

  return {
    id: Number(portfolio.id ?? 0),
    overview: String(portfolio.overview ?? ''),
    languages: Array.isArray(portfolio.languages) ? portfolio.languages : [],
    workCulture: Array.isArray(portfolio.workCulture)
      ? portfolio.workCulture
      : Array.isArray(portfolio.work_culture)
        ? portfolio.work_culture
        : [],
    projects: projects as unknown as ReturnedPortfolio['projects'],
    references: Array.isArray(portfolio.references) ? portfolio.references : [],
    certifications: certifications as unknown as ReturnedPortfolio['certifications'],
    organizations: Array.isArray(portfolio.organizations) ? portfolio.organizations : [],
    accomplishments: accomplishments as unknown as ReturnedPortfolio['accomplishments'],
    isOverviewEnabled: flag(portfolio, 'isOverviewEnabled', 'is_overview_enabled'),
    isProjectsEnabled: flag(portfolio, 'isProjectsEnabled', 'is_projects_enabled', true),
    isReferencesEnabled: flag(portfolio, 'isReferencesEnabled', 'is_references_enabled', true),
    isLanguagesEnabled: flag(portfolio, 'isLanguagesEnabled', 'is_languages_enabled', true),
    isCertificationsEnabled: flag(
      portfolio,
      'isCertificationsEnabled',
      'is_certifications_enabled',
      true
    ),
    isWorkCultureEnabled: flag(portfolio, 'isWorkCultureEnabled', 'is_work_culture_enabled', true),
    isOrganizationsEnabled: flag(
      portfolio,
      'isOrganizationsEnabled',
      'is_organizations_enabled',
      true
    ),
    isAccomplishmentsEnabled: flag(
      portfolio,
      'isAccomplishmentsEnabled',
      'is_accomplishments_enabled',
      true
    ),
  };
}
